import { useMediaQuery } from 'react-responsive'

export function useBreakpoint() {
  // Bootstrap breakpoints
  const isXs = useMediaQuery({ maxWidth: 575 })
  const isSm = useMediaQuery({ minWidth: 576, maxWidth: 767 })
  const isMd = useMediaQuery({ minWidth: 768, maxWidth: 991 })
  const isLg = useMediaQuery({ minWidth: 992, maxWidth: 1199 })
  const isXl = useMediaQuery({ minWidth: 1200 })

  if (isXs) return 'xs'
  if (isSm) return 'sm'
  if (isMd) return 'md'
  if (isLg) return 'lg'
  if (isXl) return 'xl'
  return 'md' // default
}
